import React, { useEffect, useState } from 'react';
import { TouchableOpacity, View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';

import { AppHeader } from '../../../components/common';
import { AppButton, AppText } from '../../../components/form';
import { UserActions } from '../../../redux/reducers/userReducer';
import styles from './styles';

const BtnTarget = ({ text, onPress, selected }) => (
  <TouchableOpacity
    style={selected ? styles.baseButtomSelected : styles.baseButtom}
    onPress={onPress}
  >
    <View style={styles.viewTextButton}>
      <AppText style={styles.textButton}>{text}</AppText>
    </View>
  </TouchableOpacity>
);

const dataButtons = [
  { label: 'EMAGRECIMENTO', value: 'emagrecimento' },
  { label: 'HIPERTROFIA', value: 'hipertrofia' },
  { label: 'YOGA', value: 'yoga' },
  { label: 'FORTALECIMENTO MUSCULAR', value: 'musculacao' },
  { label: 'ALONGAMENTO/FLEXIBILIDADE', value: 'alongamento' },
  { label: 'CONDICIONAMENTO FÍSICO', value: 'condicionamento_fisico' },
  { label: 'TREINAMENTO FUNCIONAL', value: 'treinamento_funcional' },
  { label: 'RELAXAMENTO', value: 'relaxamento' },
  { label: 'PILATES', value: 'pilates' },
  { label: 'ESPORTES', value: 'esportes' },
  { label: 'CONSULTORIA', value: 'consultoria' },
  { label: 'DOENÇAS METABÓLICAS', value: 'doencas_metabolicas' },
  { label: 'TÊNIS', value: 'tenis' },
  { label: 'REABILITAÇÃO FÍSICA', value: 'reabilitacoes' },
  { label: 'TERCEIRA IDADE', value: 'terceira_idade' },
  { label: 'CADEIRANTE', value: 'cadeirantes' },
  { label: 'DANÇA', value: 'danca' },
  { label: 'ARTES MARCIAIS', value: 'artes_marciais' },
  { label: 'GINÁSTICA LABORAL', value: 'laboral' },
  { label: 'PATOLOGIAS', value: 'patologias' },
  { label: 'GESTANTES', value: 'gestantes' },
];

export default function selectTargets({ navigation }) {
  const { userSignUp } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: UserActions.UPDATE_SIGNUP,
      userSignUp: {
        ...userSignUp, objetivo1: '', objetivo2: '', objetivo3: '',
      },
    });
  }, []);
  const [targets, setTargets] = useState([]);

  const handleTarget = (index) => {
    const tempTargets = [...targets];
    const findTarget = targets.findIndex((item) => item === index);

    if (findTarget >= 0) {
      tempTargets.splice(findTarget, 1);
      setTargets(tempTargets);
      return;
    }

    if (targets.length >= 3) {
      return;
    }

    tempTargets.push(index);
    setTargets(tempTargets);
  };
  const handleContinue = () => {
    dispatch({
      type: UserActions.UPDATE_SIGNUP,
      userSignUp: {
        ...userSignUp, objetivo1: dataButtons[targets[0]]?.value, objetivo2: dataButtons[targets[1]]?.value, objetivo3: dataButtons[targets[2]]?.value,
      },
    });
    navigation.navigate('Profile Trainer', { screen: 'Como Funciona PF' });
  };
  return (
    <>
      <AppHeader navigation={navigation} hasBack title="Objetivos" />
      <View style={styles.container}>
        <AppText style={styles.title}>Escolha até 3 Objetivos</AppText>

        <View>
          {dataButtons.map((target, index) => (
            <BtnTarget
              key={index}
              text={target.label}
              selected={!(targets.findIndex((item) => item === index) < 0)}
              onPress={() => handleTarget(index)}
            />
          ))}
          <AppButton
            disabled={targets.length === 0}
            onPress={handleContinue}
            style={styles.buttonNext}
            labelStyle={styles.textButtonNext}
            label="Continuar"
          />
        </View>
      </View>
    </>
  );
}
